import(/* webpackMode: "eager" */ "/home/ubuntu/Sarvaa_Technologies/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Sarvaa_Technologies/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Sarvaa_Technologies/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Sarvaa_Technologies/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Sarvaa_Technologies/public/header/div/firstdivimg.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Sarvaa_Technologies/src/app/components/ContactUs.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Sarvaa_Technologies/src/app/components/header.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Sarvaa_Technologies/src/app/components/homecomp.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Sarvaa_Technologies/src/app/styles/popup.css");
